import React, { useContext } from 'react';
import { CSSTransition } from 'react-transition-group';
import Button3 from './Button3';
import { ModalContext } from '../context/ModalContext';

export default function MainWrap() {
    const { showModal, close } = useContext(ModalContext);

    return (
        <CSSTransition
            in={showModal}
            timeout={500}
            classNames="modal"
            unmountOnExit
        >
            <div className='fixed inset-0 flex items-center justify-center z-50 '>
                <div className='h-auto rounded-xl w-[95%] lg:w-2/5' data-aos-duration="500">
                    <div className='justify-center'>
                        <div className='border-0 shadow-2xl relative flex flex-col min-w-0 bg-white bg-clip-border rounded'>
                            <div className='p-0'>
                                <div className='mx-0'>
                                    <div className='p-6 w-200px'>
                                        <div className='mb-2'>
                                            <button className='absolute right-4 top-2 font-bold' onClick={() => close()}>
                                                X
                                            </button>
                                            <h3 className='text-[#020f66c6] font-bold text-2xl'>
                                                Please enter your credentials
                                            </h3>
                                        </div>
                                        <form>
                                            <div className='mb-4'>
                                                <label htmlFor='username' className='text-[#7e7e7e] cursor-pointer text-sm font-normal'>Username:</label>
                                                <input type="text" className='block w-full py-[0.375rem] px-[0.75rem] text-base leading-6 text-[#495057] bg-white bg-clip-padding border border-[#ced4da]' id="username" required />
                                            </div>
                                            <div className='mb-4'>
                                                <label htmlFor='password' className='text-[#7e7e7e] cursor-pointer text-sm font-normal'>Password:</label>
                                                <input type="password" className='block w-full py-[0.375rem] px-[0.75rem] text-base leading-6 text-[#495057] bg-white bg-clip-padding border border-[#ced4da]' id="password" required />
                                            </div>
                                            <div className='flex justify-center'>
                                                <Button3 text='log in' />
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CSSTransition>
    );
}
